import React, { Component, Fragment } from "react";
import { shopContext } from "../../contexts/aniplus";
import { withRouter } from "react-router-dom";
import axios from "axios";

//import NewContentList from './NewContentList'
// import moment from "moment";

import ContentItem8 from "../../components/event/ContentItem8";

// import "../../css/event230701.css";

// import { ToastContainer, toast } from "react-toastify"; //토스트(toast)
// import { confirmAlert } from "react-confirm-alert"; //알럿창(alert confirm)

class Event202307_contentList extends Component {
  state = {
    //eventCode: 0,
    intReturn: -101,
    list: [],
  };
  componentDidMount = () => {
    const eventCode = this.props.childProps.eventCode;
    this._getContentList(eventCode);
  };

  _getContentList = async (eventCode) => {
    // const { loginId } = this.props;

    // const curDate = new Date();
    // const today = moment(curDate).format("YYYY-MM-DD HH:mm:ss");

    const result = await this._getContentListApi(eventCode);
    const intReturn = result.data[0].intReturn;
    const contentList = result.data[0].listData;

    //console.log(contentList)

    if (intReturn === 0) {
      this.setState({
        intReturn,
        contentList,
      });
    }
  };

  _getContentListApi = (eventCode) => {
    const { apiUrl, loginId } = this.props;

    return axios
      .post(apiUrl + "/event_202307_content", {
        params: {
          eventCode: eventCode,
          userid: loginId,
        },
      })
      .then((response) => response)
      .catch((error) => {
        //console.log('error...')
      });
  };

  /*
    _expectApi = (keycode, contentSerial, grade) => {
        const { apiUrl, loginId } = this.props;
        
        return axios.post(apiUrl + '/event_202201_expect', {
            params: {
                keycode: keycode,
                contentSerial: contentSerial,
                grade: grade
            }
        })
    }
    */
  _renderItem = () => {
    const { contentList } = this.state;

    const list = contentList.map((item, index) => {
      return (
        <ContentItem8
          key={index}
          contentSerial={item.contentSerial}
          img={item.img}
          comment={item.comment}
          title={item.title}
          alramFlag={item.alram}
          grade={item.rank}
        />
      );
    });
    return list;
  };
  _renderNull = () => {
    const { eventCode } = this.props.childProps;
    let test = [];

    if (eventCode === 1) {
      test = [];
    } else if (eventCode === 2) {
      test = [];
    } else if (eventCode === 3) {
      test = [];
    } else if (eventCode === 4) {
      test = [];
    } else if (eventCode === 5) {
      test = [];
    }

    const list = test.map((item, index) => {
      return (
        <li key={index} style={{ width: 224, height: 502 }}>
          <div className="thumb"></div>
        </li>
      );
    });
    return list;
  };
  render() {
    const { intReturn, contentList } = this.state;
    // const { eventCode } = this.props.childProps;

    return (
      <Fragment>
        {intReturn === 0 ? (
          <ul className="list">
            <li>
              {contentList ? this._renderItem() : null}
              {contentList ? this._renderNull() : null}
            </li>
          </ul>
        ) : (
          <Fragment></Fragment>
        )}
      </Fragment>
    );
  }
}

export default shopContext(withRouter(Event202307_contentList));
